var map = {
	"./br-ac.svg": 61,
	"./br-al.svg": 62,
	"./br-am.svg": 63,
	"./br-ap.svg": 64,
	"./br-ba.svg": 65,
	"./br-br.svg": 32,
	"./br-ce.svg": 66,
	"./br-df.svg": 67,
	"./br-es.svg": 68,
	"./br-go.svg": 69,
	"./br-ma.svg": 70,
	"./br-mg.svg": 71,
	"./br-ms.svg": 72,
	"./br-mt.svg": 73,
	"./br-pa.svg": 74,
	"./br-pb.svg": 75,
	"./br-pe.svg": 76,
	"./br-pi.svg": 77,
	"./br-pr.svg": 78,
	"./br-rj.svg": 79,
	"./br-rn.svg": 80,
	"./br-ro.svg": 81,
	"./br-rr.svg": 82,
	"./br-rs.svg": 83,
	"./br-sc.svg": 84,
	"./br-se.svg": 85,
	"./br-sp.svg": 86,
	"./br-to.svg": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;